import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import OtpInput from 'react-otp-input'
import { Button } from '@/design-system'
import { ErrorBanner, FieldError, FormPage, FormSub, FormTitle, FormWrap, SwapRow } from './__styled'
import { validateEmail } from '@/utils/helper'

interface FormProps {
  error: string
  loading: boolean
  user: string
  onSubmit: (code: string) => void
  onResend: () => void
}

export default function SignUpForm3({ error, loading, user, onSubmit, onResend }: FormProps) {
  const [code, setCode] = useState('')
  const [time, setTime] = useState(60)

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((t) => t - 1)
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const onAgree = () => onSubmit(code)

  const onResendCode = () => {
    setTime(60)
    onResend()
  }

  return (
    <FormPage>
      <FormWrap>
        <FormTitle>Verify it's you</FormTitle>
        <FormSub>
          We sent a code to your {validateEmail(user) ? 'email' : 'phone'} —{' '}
          <b>{user}</b>
        </FormSub>

        <OtpInput
          value={code}
          onChange={setCode}
          numInputs={6}
          inputStyle={{
            width: '100%',
            height: 44,
            borderRadius: 11,
            fontSize: 18,
            fontWeight: 700,
            fontFamily: 'var(--ds-font)',
            color: 'var(--ds-ink)',
            boxShadow: 'inset 0 0 0 1px var(--ds-border-strong)',
            border: 'none',
            outline: 'none',
            background: '#fff',
            transition: 'box-shadow var(--ds-duration-fast) var(--ds-ease)',
          }}
          containerStyle={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 20 }}
          renderInput={(props) => (
            <input
              {...props}
              onFocus={(e) => {
                e.target.style.boxShadow = 'inset 0 0 0 1.5px var(--ds-accent-deep-b)'
              }}
              onBlur={(e) => {
                e.target.style.boxShadow = 'inset 0 0 0 1px var(--ds-border-strong)'
              }}
            />
          )}
        />

        {!loading && !!error && (
          <ErrorBanner>
            <FieldError sx={{ mt: 0 }}>{error}</FieldError>
          </ErrorBanner>
        )}

        <Box display='flex' justifyContent='center' mb={2}>
          {time > 0 ? (
            <FormSub sx={{ mb: 0, fontSize: 13 }}>
              Resend code in <b>{time}</b>s
            </FormSub>
          ) : (
            <Button variant='ghost' size='sm' onClick={onResendCode}>
              Resend code
            </Button>
          )}
        </Box>

        <Button
          variant='spectrum'
          size='lg'
          fullWidth
          disabled={code.length < 6}
          loading={loading}
          onClick={onAgree}
        >
          Continue →
        </Button>

        <SwapRow>
          Got an account? <Link to='/login'>Sign in</Link>
        </SwapRow>
      </FormWrap>
    </FormPage>
  )
}
